import { cn } from '@/utils/cn';

export const XLogo = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className={cn('w-6', className)}
			viewBox="0 0 20 20"
			fill="none"
		>
			<path
				d="M11.4893 8.77491L17.3176 2H15.9365L10.8758 7.88256L6.83381 2H2.17188L8.28411 10.8955L2.17188 18H3.55307L8.89729 11.7878L13.1659 18H17.8278L11.4893 8.77491ZM9.59756 10.9738L8.97826 10.088L4.05073 3.03974H6.17216L10.1487 8.72795L10.768 9.61374L15.9371 17.0075H13.8157L9.59756 10.9738Z"
				fill="currentColor"
			/>
		</svg>
	);
};
